const Illustration = {
  EmptySpace: ({ size = 150 }) => (
    <svg
      fill="none"
      viewBox="0 0 150 150"
      style={{
        width: size + "px",
        height: size + "px",
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#DDD"
        d="M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z"
      />
      <path
        fill="#fff"
        d="M120 150H30V53a16.018 16.018 0 0 0 16-16h58a15.906 15.906 0 0 0 4.691 11.308A15.89 15.89 0 0 0 120 53v97Z"
      />
      <path
        fill="#999"
        d="M75 102c13.255 0 24-10.745 24-24S88.255 54 75 54 51 64.745 51 78s10.745 24 24 24Z"
      />
      <path
        fill="#fff"
        d="M83.485 89.314 75 80.829l-8.485 8.485-2.829-2.829L72.172 78l-8.486-8.485 2.829-2.829L75 75.172l8.485-8.486 2.829 2.829L77.828 78l8.486 8.485-2.829 2.829Z"
      />
      <path
        fill="#D8D8D8"
        d="M88 108H62a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6ZM97 120H53a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6Z"
      />
    </svg>
  ),
  EmptyList: ({ size = 150 }) => (
    <svg
      fill="none"
      viewBox="0 0 150 153"
      style={{
        width: size + "px",
        height: size * (153 / 150) + "px",
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z"
        fill="#F1F1F1"
      />
      <g filter="url(#a)">
        <mask
          id="c"
          style={{
            maskType: "alpha",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={150}
          height={150}
        >
          <path
            d="M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z"
            fill="url(#b)"
          />
        </mask>
        <g mask="url(#c)">
          <path
            d="M118 43H32a5 5 0 0 0-5 5v105a5 5 0 0 0 5 5h86a5 5 0 0 0 5-5V48a5 5 0 0 0-5-5Z"
            fill="#fff"
          />
        </g>
      </g>
      <path
        d="M66 53H40a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6ZM66 95H40a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z"
        fill="#E1EBFA"
      />
      <path
        d="M108 68H42a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h66a4 4 0 0 0 4-4V72a4 4 0 0 0-4-4Z"
        stroke="#1485FD"
        strokeWidth={2}
      />
      <path
        d="M108 109H42a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h66a5 5 0 0 0 5-5v-8a5 5 0 0 0-5-5Z"
        fill="#DFEAFB"
      />
      <path d="M53 32a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" fill="#fff" />
      <path d="M75 32a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" fill="#1485FD" />
      <path d="M97 32a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" fill="#fff" />
      <path d="M86 88a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" fill="#DFEAFB" />
      <path
        d="M89.907 104.37c-.8 0-1.547 0-2.227-.043a4.567 4.567 0 0 1-3.884-2.749l-4.219-8.338a1.8 1.8 0 0 1 .182-2.529 1.628 1.628 0 0 1 1.035-.359 1.918 1.918 0 0 1 1.437.714l1.916 2.615.029.034V83.78a1.858 1.858 0 1 1 3.717 0v6.5a1.73 1.73 0 1 1 3.444 0v1.355a1.73 1.73 0 1 1 3.444 0v1.044a1.73 1.73 0 1 1 3.444 0v6.337c-.034 1.949-.915 5.235-4.014 5.235-.225.01-2.131.12-4.3.12l-.004-.001Z"
        fill="#1485FD"
        stroke="#fff"
      />
      <defs>
        <linearGradient
          id="b"
          x1={75}
          y1={0}
          x2={75}
          y2={150}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3ECFA" />
          <stop offset={1} stopColor="#DAE7FF" />
        </linearGradient>
        <filter
          id="a"
          x={21}
          y={34}
          width={108}
          height={119}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-3} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_506_25"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_506_25"
            result="shape"
          />
        </filter>
      </defs>{" "}
    </svg>
  ),
  NoMatch: ({ size = 150 }) => (
    <svg
      fill="none"
      viewBox="0 0 187 150"
      style={{
        width: size + "px",
        height: size * (150 / 187) + "px",
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z"
        fill="#f1f1f1"
      />
      <g filter="url(#a)">
        <path
          d="M41 34h135a5.002 5.002 0 0 1 5 5v25a5.002 5.002 0 0 1-5 5H41a5 5 0 0 1-5-5V39a5 5 0 0 1 5-5Z"
          fill="#fff"
        />
      </g>
      <path d="M105 42H79a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z" fill="#B4DAFF" />
      <path d="M123 55H79a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6Z" fill="#DEE9FC" />
      <path
        d="M68 51.5C68 43.492 61.508 37 53.5 37S39 43.492 39 51.5 45.492 66 53.5 66 68 59.508 68 51.5Z"
        fill="#2967C4"
      />
      <path
        d="M52.6 56.194a5.562 5.562 0 0 0 3.425-1.18l3.075 3.075.989-.989-3.076-3.076a5.59 5.59 0 1 0-4.413 2.17Zm0-9.794a4.2 4.2 0 1 1 0 8.4 4.2 4.2 0 0 1 0-8.4Z"
        fill="#fff"
      />
      <g filter="url(#b)">
        <path
          d="M161 79H26a5 5 0 0 0-5 5v25a5 5 0 0 0 5 5h135a5 5 0 0 0 5-5V84a5 5 0 0 0-5-5Z"
          fill="#fff"
        />
      </g>
      <path d="M90 87H64a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6Z" fill="#B4DAFF" />
      <path d="M108 100H64a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6Z" fill="#DEE9FC" />
      <path
        d="M53 96.5C53 88.492 46.508 82 38.5 82S24 88.492 24 96.5 30.492 111 38.5 111 53 104.508 53 96.5Z"
        fill="#2967C4"
      />
      <path
        d="M37.6 101.194a5.565 5.565 0 0 0 3.425-1.18l3.075 3.075.989-.989-3.076-3.076a5.59 5.59 0 1 0-4.413 2.17Zm0-9.794a4.2 4.2 0 1 1 0 8.4 4.2 4.2 0 0 1 0-8.4Z"
        fill="#fff"
      />
      <defs>
        <filter
          id="a"
          x={30}
          y={31}
          width={157}
          height={47}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_505_2" />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_505_2"
            result="shape"
          />
        </filter>
        <filter
          id="b"
          x={15}
          y={76}
          width={157}
          height={47}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_505_2" />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_505_2"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),

  EmptyArray: ({ size = 150 }) => (
    <svg
      fill="none"
      viewBox="0 0 150 178"
      style={{
        width: size + "px",
        height: size * (178 / 150) + "px",
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75 167C116.421 167 150 133.421 150 92C150 50.5786 116.421 17 75 17C33.5786 17 0 50.5786 0 92C0 133.421 33.5786 167 75 167Z"
        fill="#DDDDDD"
      />
      <g filter="url(#filter0_d_402_85)">
        <path
          d="M118 60H32C29.2386 60 27 62.2386 27 65V170C27 172.761 29.2386 175 32 175H118C120.761 175 123 172.761 123 170V65C123 62.2386 120.761 60 118 60Z"
          fill="white"
        />
      </g>
      <path
        d="M65 75H39C37.3431 75 36 76.3431 36 78C36 79.6569 37.3431 81 39 81H65C66.6569 81 68 79.6569 68 78C68 76.3431 66.6569 75 65 75Z"
        fill="#D8D8D8"
      />
      <path
        d="M83 88H39C37.3431 88 36 89.3431 36 91C36 92.6569 37.3431 94 39 94H83C84.6569 94 86 92.6569 86 91C86 89.3431 84.6569 88 83 88Z"
        fill="#D8D8D8"
      />
      <path
        d="M65 102H39C37.3431 102 36 103.343 36 105C36 106.657 37.3431 108 39 108H65C66.6569 108 68 106.657 68 105C68 103.343 66.6569 102 65 102Z"
        fill="#D8D8D8"
      />
      <path
        d="M83 115H39C37.3431 115 36 116.343 36 118C36 119.657 37.3431 121 39 121H83C84.6569 121 86 119.657 86 118C86 116.343 84.6569 115 83 115Z"
        fill="#D8D8D8"
      />
      <path
        d="M65 129H39C37.3431 129 36 130.343 36 132C36 133.657 37.3431 135 39 135H65C66.6569 135 68 133.657 68 132C68 130.343 66.6569 129 65 129Z"
        fill="#D8D8D8"
      />
      <path
        d="M83 142H39C37.3431 142 36 143.343 36 145C36 146.657 37.3431 148 39 148H83C84.6569 148 86 146.657 86 145C86 143.343 84.6569 142 83 142Z"
        fill="#D8D8D8"
      />
      <g filter="url(#filter1_d_402_85)">
        <path
          d="M118 9H32C29.2386 9 27 11.2386 27 14V44C27 46.7614 29.2386 49 32 49H118C120.761 49 123 46.7614 123 44V14C123 11.2386 120.761 9 118 9Z"
          fill="#999999"
        />
      </g>
      <path
        d="M65 20H39C37.3431 20 36 21.3431 36 23C36 24.6569 37.3431 26 39 26H65C66.6569 26 68 24.6569 68 23C68 21.3431 66.6569 20 65 20Z"
        fill="#D8D8D8"
      />
      <path
        d="M83 33H39C37.3431 33 36 34.3431 36 36C36 37.6569 37.3431 39 39 39H83C84.6569 39 86 37.6569 86 36C86 34.3431 84.6569 33 83 33Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_402_85"
          x="21"
          y="51"
          width="108"
          height="127"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_402_85"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_402_85"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_402_85"
          x="21"
          y="0"
          width="108"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_402_85"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_402_85"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),

  Connectivity: ({ size = 267 }) => (
    <svg
      style={{
        width: size,
        height: size * (198 / 267),
      }}
      fill="none"
      viewBox="0 0 267 198"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M77.5562 32.8859C77.5562 32.8859 107.58 55.6699 153.224 13.0679C193.76 -24.7658 226.859 34.9274 227.09 63.5134C227.39 100.543 186.554 130.173 206.372 154.495C226.189 178.817 167.07 218.981 135.208 184.222C95.5722 140.983 84.8345 176.114 62.2424 176.114C46.0278 176.114 12.7376 135.825 35.2181 105.851C54.1352 80.6287 43.8181 72.2578 38.822 63.5134C31.6149 50.9021 48.7303 16.6714 77.5562 32.8859Z"
        fill="#e6e6e6"
      />
      <path
        d="M198.093 83.2349C199.706 83.8345 201.47 83.8745 203.148 83.4893C210.178 81.8757 234.351 77.6031 230.151 96.3349C229.236 100.051 215.078 120.864 235.24 128.462C236.718 129.026 238.28 129.334 239.861 129.372C246.068 129.5 258.37 128.034 263.518 122.793C269.737 116.463 262.943 119.465 262.943 119.465C262.943 119.465 239.299 129.783 230.947 118.836C230.018 117.618 229.426 115.849 229.256 114.326C228.962 111.686 230.135 108.197 231.675 105.159C233.76 101.048 243.767 82.5554 222.039 77.1682C217.034 75.9762 209.764 74.9055 200.39 78.8521C194.923 81.154 196.134 82.5071 198.093 83.2349Z"
        fill="#DCDCDC"
      />
      <path
        d="M202.93 76.3312L196.637 78.6865C194.464 79.4996 193.362 81.9198 194.175 84.0922L194.487 84.9257C195.3 87.0981 197.721 88.2001 199.893 87.3871L206.186 85.0317C208.359 84.2187 209.461 81.7985 208.648 79.6261L208.336 78.7925C207.523 76.6201 205.102 75.5181 202.93 76.3312Z"
        fill="#929292"
      />
      <path
        d="M164.302 83.1466L143.547 90.9143C142.461 91.3208 141.91 92.5309 142.316 93.6171L142.398 93.8356C142.804 94.9218 144.015 95.4728 145.101 95.0663L165.856 87.2985C166.942 86.892 167.493 85.6819 167.086 84.5957L167.005 84.3772C166.598 83.291 165.388 82.74 164.302 83.1466Z"
        fill="white"
      />
      <path
        d="M170.093 98.6235L149.338 106.391C148.252 106.798 147.701 108.008 148.107 109.094L148.189 109.313C148.595 110.399 149.806 110.95 150.892 110.543L171.647 102.776C172.733 102.369 173.284 101.159 172.877 100.073L172.796 99.8542C172.389 98.768 171.179 98.217 170.093 98.6235Z"
        fill="white"
      />
      <path
        d="M189.255 72.5843L172.434 78.8799C170.261 79.6929 169.159 82.1132 169.972 84.2856L175.715 99.6307C176.528 101.803 178.949 102.905 181.121 102.092L197.942 95.7964C200.115 94.9834 201.217 92.5632 200.404 90.3907L194.661 75.0456C193.848 72.8732 191.427 71.7712 189.255 72.5843Z"
        fill="#C2C2C2"
      />
      <path
        d="M174.171 76.6101L157.35 82.9058C155.177 83.7188 154.075 86.139 154.888 88.3115L161.74 106.619C162.553 108.791 164.973 109.893 167.146 109.08L183.967 102.785C186.139 101.971 187.241 99.5513 186.428 97.3788L179.577 79.0715C178.764 76.8991 176.343 75.7971 174.171 76.6101Z"
        fill="#CECECE"
      />
      <path
        d="M176.805 72.895L176.673 72.9443C175.225 73.4864 174.49 75.0998 175.032 76.5481L184.631 102.195C185.173 103.643 186.786 104.378 188.235 103.836L188.367 103.786C189.815 103.244 190.549 101.631 190.007 100.182L180.409 74.5359C179.867 73.0876 178.253 72.3529 176.805 72.895Z"
        fill="#7E7E7E"
      />
      <path
        d="M5.28195 89.2923C5.28195 89.2923 39.0651 79.7983 34.1603 101.672C33.3086 105.132 21.0475 122.953 35.6523 131.509C38.7883 133.346 42.4073 134.16 46.0416 134.141C52.5576 134.107 62.8875 132.853 67.5281 128.13C73.7474 121.798 66.9529 124.801 66.9529 124.801C66.9529 124.801 47.5508 132.782 37.569 126.42C34.1607 124.248 32.6158 120.042 33.5414 116.107C34.0144 114.153 34.7348 112.267 35.6851 110.495C37.8559 106.429 47.7771 87.8913 26.0491 82.5041C21.0439 81.3121 13.7741 80.2414 4.40038 84.188C-4.97333 88.1346 5.28195 89.2923 5.28195 89.2923Z"
        fill="#DCDCDC"
      />
      <path
        d="M72.0705 119.906L65.7773 122.262C63.6049 123.075 62.5029 125.495 63.3159 127.667L63.6279 128.501C64.4409 130.673 66.8612 131.775 69.0336 130.962L75.3268 128.607C77.4993 127.794 78.6013 125.374 77.7882 123.201L77.4762 122.368C76.6632 120.195 74.243 119.093 72.0705 119.906Z"
        fill="#929292"
      />
      <path
        d="M82.7038 109.552L73.3769 113.042C71.2045 113.856 70.1025 116.276 70.9155 118.448L75.4129 130.465C76.226 132.637 78.6462 133.739 80.8186 132.926L90.1456 129.436C92.318 128.622 93.42 126.202 92.6069 124.03L88.1095 112.013C87.2965 109.841 84.8762 108.739 82.7038 109.552Z"
        fill="#C2C2C2"
      />
      <path
        d="M98.2313 100.3L84.3222 105.506C82.1498 106.319 81.0478 108.739 81.8608 110.912L88.7126 129.219C89.5256 131.391 91.9459 132.493 94.1183 131.68L108.027 126.475C110.2 125.662 111.302 123.241 110.489 121.069L103.637 102.762C102.824 100.589 100.404 99.4871 98.2313 100.3Z"
        fill="#CECECE"
      />
      <path
        d="M101.176 96.5087L101.044 96.5581C99.5959 97.1001 98.8613 98.7136 99.4033 100.162L109.002 125.808C109.544 127.257 111.157 127.991 112.606 127.449L112.738 127.4C114.186 126.858 114.921 125.245 114.379 123.796L104.78 98.1496C104.238 96.7014 102.624 95.9667 101.176 96.5087Z"
        fill="#7E7E7E"
      />
      <path
        d="M136.694 80.1698C136.193 80.1142 135.734 79.8665 135.412 79.4787C135.09 79.0909 134.931 78.5934 134.968 78.0908L136.006 59.1348C136.068 58.0025 137.024 57.1422 138.109 57.2423L139.621 57.3823C140.706 57.4824 141.483 58.5023 141.332 59.6266L138.781 78.4427C138.723 78.9439 138.473 79.4031 138.084 79.7249C137.695 80.0466 137.198 80.206 136.694 80.1698Z"
        fill="#8B8B8B"
      />
      <path
        d="M127.732 81.8041C127.577 81.8499 127.413 81.8645 127.252 81.8472C127.09 81.8299 126.934 81.7809 126.791 81.7031C126.649 81.6253 126.523 81.5202 126.421 81.3937C126.319 81.2673 126.243 81.122 126.198 80.9662L122.492 69.1746C122.384 68.8393 122.413 68.4748 122.574 68.1613C122.735 67.8478 123.013 67.6108 123.348 67.5023L124.308 67.2128C124.472 67.1647 124.645 67.1513 124.815 67.1734C124.985 67.1955 125.149 67.2527 125.296 67.3412C125.443 67.4297 125.57 67.5478 125.669 67.6878C125.767 67.8279 125.836 67.987 125.871 68.155L128.618 80.2363C128.694 80.561 128.645 80.9027 128.481 81.1932C128.317 81.4838 128.05 81.7019 127.732 81.8041Z"
        fill="#8B8B8B"
      />
      <path
        d="M122.732 88.6041C122.068 89.4269 120.732 89.4171 119.704 88.5819L101.452 73.7528C100.362 72.867 100.04 71.4008 100.745 70.5286L101.727 69.3123C102.431 68.4397 103.878 68.5112 104.91 69.4697L122.18 85.5152C123.152 86.4187 123.396 87.7813 122.732 88.6041Z"
        fill="#8B8B8B"
      />
      <path
        d="M131.169 126.906C131.639 127.088 132.02 127.445 132.232 127.902C132.444 128.359 132.471 128.88 132.306 129.357L126.462 147.419C126.113 148.498 124.969 149.085 123.945 148.711L122.518 148.19C121.495 147.816 121.003 146.631 121.438 145.583L128.709 128.043C128.893 127.573 129.252 127.192 129.71 126.981C130.169 126.769 130.691 126.742 131.169 126.906Z"
        fill="#8B8B8B"
      />
      <path
        d="M140.25 127.615C140.413 127.61 140.574 127.638 140.726 127.696C140.878 127.754 141.016 127.841 141.134 127.953C141.252 128.064 141.347 128.198 141.413 128.346C141.48 128.495 141.516 128.654 141.521 128.817L142.092 141.164C142.111 141.516 141.989 141.86 141.754 142.123C141.518 142.385 141.189 142.543 140.837 142.562L139.835 142.597C139.664 142.601 139.493 142.57 139.334 142.505C139.176 142.441 139.032 142.344 138.913 142.22C138.793 142.097 138.701 141.951 138.641 141.79C138.581 141.629 138.555 141.458 138.564 141.287L138.995 128.905C139.004 128.571 139.138 128.253 139.37 128.014C139.603 127.775 139.917 127.633 140.25 127.615Z"
        fill="#8B8B8B"
      />
      <path
        d="M146.821 122.317C147.673 121.691 148.962 122.042 149.743 123.112L163.602 142.11C164.43 143.245 164.367 144.744 163.462 145.408L162.202 146.333C161.298 146.997 159.918 146.558 159.165 145.368L146.565 125.444C145.856 124.323 145.969 122.943 146.821 122.317Z"
        fill="#8B8B8B"
      />
    </svg>
  ),
  Empty: ({ size = 212 }) => (
    <svg
      fill="none"
      style={{
        width: size,
        height: (size * 214) / 212,
      }}
      viewBox="0 0 212 214"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M68.7922 208.485C83.6489 217.44 94.2476 213.722 98.3052 206.542C106.152 192.655 132.242 164.258 173.588 154.66C228.348 141.948 216.912 108.196 183.249 90.4842C149.586 72.7725 124.415 48.2651 128.225 21.6176C132.034 -5.02983 94.2889 -14.2161 77.5029 37.0447C66.6554 70.1713 47.216 79.0461 34.8198 81.1794C23.1367 83.1899 10.3568 85.7126 4.12469 95.7971C-3.43755 108.033 -0.798692 120.41 30.8627 128.9C75.7301 140.93 35.492 188.413 68.7922 208.485Z"
        fill="#e6e6e6"
      />
      <path
        d="M30.1915 150.424C30.8202 150.064 37.9166 147.06 73.2195 163.518C73.1166 163.658 73.0729 163.724 73.0729 163.724C73.0729 163.724 36.3721 176.084 29.1813 160.858C27.0339 156.325 27.6492 153.203 30.1302 150.459L30.1915 150.424Z"
        fill="#929292"
      />
      <path
        d="M148.847 156.652C141.177 163.1 129.149 167.78 117.543 161.557C119.377 160.385 121.271 159.178 123.203 157.929C134.859 150.44 145.125 155.451 148.847 156.652Z"
        fill="#929292"
      />
      <path
        d="M162.586 77.3488C170.422 142.601 151.799 154.443 149.726 156.242C149.126 156.763 148.883 156.725 147.975 156.491L147.96 156.5C144.119 155.482 134.859 150.44 123.203 157.928C121.271 159.177 119.377 160.384 117.543 161.556C105.653 169.097 96.0512 174.411 89.1336 171.327C83.2661 168.333 77.9756 165.743 73.2194 163.518C37.9165 147.06 30.8201 150.064 30.1914 150.424C30.9209 150.027 37.6134 146.317 46.6246 139.793C46.6553 139.776 46.6859 139.758 46.6925 139.734C58.7373 131.005 74.8676 117.249 86.4622 99.5541C94.3552 87.5213 102.077 57.017 116.976 51.0317C147.595 39.6091 161.314 64.0762 162.586 77.3488Z"
        fill="#CECECE"
      />
      <path
        d="M128.729 76.204C129.68 73.6942 129.587 71.3328 128.522 70.9295C127.457 70.5263 125.824 72.234 124.873 74.7438C123.923 77.2535 124.015 79.615 125.08 80.0182C126.145 80.4214 127.779 78.7137 128.729 76.204Z"
        fill="white"
      />
      <path
        d="M148.224 79.4063C148.898 76.8085 148.551 74.4709 147.449 74.1851C146.346 73.8993 144.907 75.7736 144.233 78.3714C143.56 80.9693 143.907 83.3069 145.009 83.5926C146.111 83.8784 147.551 82.0041 148.224 79.4063Z"
        fill="white"
      />
      <path
        d="M136.357 88.9445C136.198 88.9443 136.043 88.8895 135.919 88.7893C135.794 88.689 135.708 88.5492 135.674 88.3931C135.549 87.8281 134.994 86.1562 134.114 85.9077C133.233 85.6592 131.507 86.624 130.808 87.1301C130.658 87.239 130.47 87.2837 130.287 87.2544C130.103 87.225 129.939 87.1241 129.83 86.9737C129.721 86.8233 129.677 86.6358 129.706 86.4525C129.735 86.2692 129.836 86.105 129.987 85.9961C130.262 85.7967 132.728 84.062 134.494 84.5602C136.336 85.0799 136.975 87.7882 137.042 88.0954C137.064 88.1976 137.063 88.3036 137.039 88.4054C137.015 88.5073 136.969 88.6024 136.903 88.6839C136.837 88.7654 136.754 88.831 136.66 88.8761C136.565 88.9212 136.462 88.9446 136.357 88.9445H136.357Z"
        fill="white"
      />
    </svg>
  ),
};

export default Illustration;
